<template>
  <div>
    AppointmentsTab
  </div>
</template>

<script>
export default {
  name: 'AppointmentsTab',
};
</script>
<style scoped></style>
